import { VatBadge } from "../../common/footer/VatBadge";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { isFlyin } from "@/src/utils/generalUtils/isFlyin";
import { useEffect, useState } from "react";


export const CopyRight = () => {
    const flyin = isFlyin();
    const t = useTranslations('footer')
    const [currentYear, setCurrentYear] = useState<number | null>(null)

    useEffect(() => {
        setCurrentYear(new Date().getFullYear())
    }, [])

    if (!currentYear) return null

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 3, py: 2 }}>
            { flyin ?
                <>
                    <VatBadge size={32} />
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', fontWeight: 400 }}>
                        {t('copyright', { year: currentYear })}
                    </Typography>
                </>
                :
                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', fontWeight: 400 }}>
                    {t('copyrightCleartrip', { year: currentYear })}
                </Typography>

            }
        </Box>
    )
}